import _ from "underscore";
import { PageLevel } from "../../store/mobile/types";
import pageHTML from "./status.tmpl";
import DebugPageView from "./debugPageView";

export default class StatusView extends DebugPageView {

    private readonly template = _.template(pageHTML);

    constructor (options) {
        super(options, {
            title: "Device status",
            pageLevel: PageLevel.TWO
        });
        this.storeUnsubscribe = this.app.observeStore(state => state.mobile, () => this.render());
    }

    render() {
        void this.display(this.template({
            status: this.app.store.getState().mobile
        }));

        return this;
    }
}
